// data-collection-load
import $ from "jquery";
import debounce from "../helpers/debounce";

class CollectionLoad {
    constructor(el) {
        this.debounced = debounce(this.showCollection, 250);
        this.hourglass = `<span class="loader circle-spin"></span>`;

        this.elm = $(el);
        this.targetId = $(this.elm).data("toggle");
        this.target = $(`#${this.targetId}`);
        this.rootId = $(this.elm).data("root");
        this.root = $(`#${this.rootId}`);
        this.id = this.elm.data("collection-load");

        if (this.target.length) {
            $(this.elm).on("click", (event) => {
                event.preventDefault();
                this.debounced();
            });

            $(this.target).on("click", ".backToCollections", (event) => {
                event.preventDefault();
                $(this.target).fadeOut(400, () => {
                    $(this.root).fadeIn(400);
                });
            });
        } else {
            throw new Error("CollectionLoad target not found.");
        }
    }

    fecthCollection() {
        const lang = $("html").attr("lang");
        return $.ajax({
            url: `/${lang}/products/collection/${this.id}/${this.id}`,
            type: "GET",
            dataType: "HTML",
        });
    }

    showCollection() {
        $(this.root).fadeOut(400, () => {
            $(this.target).html(this.hourglass).fadeIn(600);

            const collectionHtml = this.fecthCollection();
            collectionHtml.then((html) => {
                $(this.target).html(`
          <div class="grid-x grid-margin-y">
            <div class="cell small-6">
              <button class="backToCollections button clear blue"><i class="icon-chevron-left"></i> Back to collections</button>
            </div>
            
            <div class="cell">
              ${html}
            </div>
          </div>
        `);

                $(this.target).foundation();
                $(this.target)
                    .find(".loader")
                    .fadeOut(600, (cb) => {
                        $(content).fadeIn(600);
                    });
            });
        });
    }
}

class CollectionLoadControll {
    constructor() {
        const collections = $("*[data-collection-load]");
        collections.each((index, el) => {
            new CollectionLoad(el);
        });
    }
}

export default new CollectionLoadControll();
